import { AxiosError } from 'axios';
import instance from '../config/axios';

export const getGuestUserDetails = async () => {
  try {
    const guestEmail = sessionStorage.getItem('guestEmail');
    const response = await instance({
      method: 'GET',
      url: `/api/v1/public/guest/get-user-details/${guestEmail}`,
    });

    return response.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};
